import useWindowSize from "@/hook/useWindowSize";
import {Skeleton} from "@mui/material";
import useMobileDetect from "next-device-detection";

export default function TransItem() {
  const detectMobile = useMobileDetect()
  const scaleRate = detectMobile.isMobile ? 1.5 : 1;

  return <div style={{
    marginTop: '16px'
  }} className="flex mt-[12px] mb-[12px]">
    <Skeleton className="me-[12px]" animation="wave" variant="circular" width={40} height={40}/>

    <div className="full-w flex-1">
      <div className="flex flex-1">
        <Skeleton animation="wave" height={24} width={200 / scaleRate}/>
        <div className="flex-1"></div>
        <Skeleton className="" animation="wave" height={24} width={100 / scaleRate}/>
      </div>

      <div className="flex flex-1">
        <Skeleton animation="wave" height={24} width={140 / scaleRate}/>
        <div className="flex-1"></div>
        <Skeleton className="" animation="wave" height={24} width={60 / scaleRate}/>
      </div>
    </div>
  </div>;
}